import http from '@/utils/http'

const initialState = () => ({
  list: []
})

export const state = initialState()

export const mutations = {
  RESET (state) {
    const newState = initialState()
    Object.keys(newState).forEach(key => {
      state[key] = newState[key]
    })
  },
  SET_LIST (state, list) {
    state.list = list
  }
}

export const getters = {
  list: state => state.list
}

export const actions = {
  fetchSubscriptions ({ commit, getters, rootGetters }, force = false) {
    // handling case when switching customers quickly
    if (!rootGetters['customers/customerGuid']) {
      commit('SET_LIST', [])
      return []
    }

    if (!force && getters.list.length) {
      return getters.list
    }

    return http({
      url: `${process.env.VUE_APP_API_URL}subscriptions/${rootGetters['auth/token']}/${rootGetters['customers/customerGuid']}`
    }).then(data => {
      commit('SET_LIST', data)

      return data
    })
  }
}
